// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonWrapper } from "@conklin/MobiusOverrides/Button/Button";
import { filterListStyles } from "@conklin/Overrides/Widgets/ProductList/ProductListFilterList";
import IconClear from "@conklin/XDL/Icons/IconClear";
import { color, createLinkIconStyles, xScreen } from "@conklin/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

filterListStyles.titleWrapper = {
    css: css`
        border-radius: 4px 4px 0 0;
        background-color: ${color("common.black")};
        padding: 12px;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

filterListStyles.filterText = {
    variant: "h5",
    color: "common.white",
    css: css`
        margin-bottom: 0;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

filterListStyles.wrapper = {
    css: css`
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    `,
};

filterListStyles.filterTag = {
    iconProps: {
        size: 8,
    },
    css: css`
        margin: 0;
        &&& ${ButtonWrapper}:hover ${IconWrapper} {
            color: ${color("common.ui10")};
        }
    `,
};

filterListStyles.clearAllLink = {
    ...createLinkIconStyles(IconClear, "small", "left", false, {
        css: css`
            width: 100%;
        `,
    }),
};
